import * as Yup from 'yup';
import { requiredErrorMessage } from 'constants/constants';
import { TargetTexts } from '../constants';
import { ValidationSchema } from 'enums/CreateProductModalEnums';

const TargetValidationSchema = Yup.object().shape({
  isSME: Yup.boolean()
    .nullable()
    .when(TargetTexts.TARGET_CATEGORY, (targetCategory, schema) =>
      targetCategory === TargetTexts.SCIENCE_BASED
        ? schema.typeError(requiredErrorMessage).required(requiredErrorMessage)
        : schema.optional()
    ),

  organizationId: Yup.number()
    .typeError(requiredErrorMessage)
    .required(requiredErrorMessage),

  baselineYear: Yup.number()
    .integer('Baseline year must be an integer')
    .typeError(requiredErrorMessage)
    .required(requiredErrorMessage),

  targetYear: Yup.number()
    .typeError(requiredErrorMessage)
    .required(requiredErrorMessage),

  targetName: Yup.string()
    .typeError(requiredErrorMessage)
    .required(requiredErrorMessage)
    .max(50, 'Name cannot exceed 50 characters')
    .matches(
      /^(?!\s+$)[\S\s]*$/,
      'Name cannot contain only spaces or leading/trailing spaces'
    )
    .matches(/^\S.*\S$|^\S$/, 'Name cannot start or end with a space'),

  targetType: Yup.string()
    .nullable()
    .when(TargetTexts.TARGET_CATEGORY, (targetCategory, schema) =>
      targetCategory === TargetTexts.SCIENCE_BASED
        ? schema.typeError(requiredErrorMessage).required(requiredErrorMessage)
        : schema.optional()
    ),

  targetCoverage: Yup.string()
    .typeError(requiredErrorMessage)
    .required(requiredErrorMessage),

  targetSettingMethod: Yup.string()
    .typeError(requiredErrorMessage)
    .required(requiredErrorMessage),

  notes: Yup.string().nullable().max(100, 'Notes cannot exceed 100 characters'),

  totalReduction: Yup.number()
    .nullable()
    .when(TargetTexts.TARGET_CATEGORY, (targetCategory, schema) =>
      targetCategory === TargetTexts.CUSTOM
        ? schema
            .positive(ValidationSchema.MIN)
            .integer(ValidationSchema.INTEGER)
            .min(1, ValidationSchema.MIN)
            .max(100, ValidationSchema.MAX)
            .typeError(requiredErrorMessage)
            .required(requiredErrorMessage)
        : schema.optional()
    ),
});

export default TargetValidationSchema;
